<template>
  <div class="ncl">
    <analyse-card @timeData="getTime" @postDate="getDate" :showFlag="showFlag"></analyse-card>
    <!-- 整体 -->
    <entirety-product-table :timeIndex="timeIndex" :dateData="dateData" v-if="pageCode === '01' && showFlag === 1"></entirety-product-table>
    <entirety-structure-table :timeIndex="timeIndex" :dateData="dateData" v-if="pageCode === '01' && showFlag === 2"></entirety-structure-table>
    <!-- 个险 -->
    <per-product-table :timeIndex="timeIndex" :dateData="dateData" v-if="pageCode === '02' && showFlag===1"></per-product-table>
    <per-structure-table :timeIndex="timeIndex" :dateData="dateData" v-if="pageCode === '02' && showFlag===2"></per-structure-table>
    <!-- 银代 -->
    <bank-product-table :timeIndex="timeIndex" :dateData="dateData" v-if="pageCode === '03' && showFlag===1"></bank-product-table>
    <bank-structure-table :timeIndex="timeIndex" :dateData="dateData" v-if="pageCode === '03' && showFlag===2"></bank-structure-table>
    <!-- 团体 -->
    <team-product-table :timeIndex="timeIndex" :dateData="dateData" v-if="pageCode === '04'"></team-product-table>
  </div>
</template>

<script>
import AnalyseCard from './components/AnalyseCard'
import EntiretyProductTable from './components/EntiretyProductTable'
import EntiretyStructureTable from './components/EntiretyStructureTable.vue'
import PerProductTable from './components/PerProductTable.vue'
import PerStructureTable from './components/PerStructureTable.vue'
import BankProductTable from './components/BankProductTable.vue'
import BankStructureTable from './components/BankStructureTable.vue'
import TeamProductTable from './components/TeamProductTable.vue'

import { popData } from '@/utils/util'

export default {
  name: 'EntiretyProduct',
  components: {
    AnalyseCard,
    EntiretyProductTable,
    EntiretyStructureTable,
    PerProductTable,
    PerStructureTable,
    BankProductTable,
    BankStructureTable,
    TeamProductTable
  },
  data () {
    return {
      showFlag: null,
      timeIndex: null,
      dateData: null
    }
  },
  computed: {
    pageCode () {
      return this.$store.state.user.pageCode
    }
  },
  methods: {
    getTime (data) {
      this.timeIndex = data
    },
    getDate (data) {
      this.dateData = data
      this.$store.state.screens.getDate = data // 存储vuex中，判断是否是历史时间
    }
  },
  mounted () {
    this.showFlag = this.$store.state.entirety.tabletype * 1
    // this.timeIndex = this.$store.state.entirety.time * 1
    window.popData = popData
  }
}
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/entirety/EntiretyProduct.vue